import React from "react";
import { render } from "react-dom";
import App from "./app";
import { SnackbarProvider } from "notistack";
import { Provider } from "react-redux";
import { store } from "./store";

// Setup logging to server
import ErrorLogger from "meta/utils/logError";
import { createStyles, makeStyles, ThemeProvider } from "@material-ui/core";
import { theme } from "meta/utils/theme";
window.addEventListener("error", ErrorLogger);

let div = document.createElement("div");
div.id = "content";
document.body.appendChild(div);

const useStyles = makeStyles(() => createStyles({ offset: { top: 32 } }));

const CustomSnackbars = ({ children }) => {
  const classes = useStyles();
  return (
    <SnackbarProvider
      anchorOrigin={{ horizontal: "right", vertical: "top" }}
      autoHideDuration={15 * 1000}
      disableWindowBlurListener
      classes={{ anchorOriginTopRight: classes.offset }}
    >
      {children}
    </SnackbarProvider>
  );
};

render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <CustomSnackbars>
        <App />
      </CustomSnackbars>
    </ThemeProvider>
  </Provider>,
  div
);
